import React from 'react'
import { LuDownload } from "react-icons/lu";
import Loader1 from '../../../images/uielements/loader/animated-loader.gif';
import LoaderFiles1 from '../../Files/Loader/animated-loader.zip'
import Loader2 from '../../../images/uielements/loader/cubecellloader.gif';
import LoaderFiles2 from '../../Files/Loader/cubecellloader.zip'
import Loader3 from '../../../images/uielements/loader/dottedloading.gif';
import LoaderFiles3 from '../../Files/Loader/dottedloading.zip'
import './loaderlist.scss'

const LoaderList = () => {
    const LoaderData = [
        {
            id: 1,
            VideoGif: Loader1,
            developer: 'SuperCodingBits',
            DownloadCode: LoaderFiles1
        },
        {
            id: 2,
            VideoGif: Loader2,
            developer: 'SuperCodingBits',
            DownloadCode: LoaderFiles2
        },
        {
            id: 3,
            VideoGif: Loader3,
            developer: 'SuperCodingBits',
            DownloadCode: LoaderFiles3
        },
    ];

    const handleDownload = (file) => {
        const link = document.createElement('a');
        link.href = file;
        link.download = file.split('/').pop(); // Extract file name from path
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="mainLoaderList">
            <div className="subLoaderList">
                {
                    LoaderData.map((item, index) => (
                        <div className="LoaderList">
                            <div className="LoaderListInfo">
                                <div className="LoaderListUIElements-image-box">
                                    <img src={item.VideoGif} alt="" />
                                    <p>{item.developer}</p>
                                </div>
                            </div>
                            <div className="LoaderListInfo">
                                <button className='DownloadBtn' onClick={() => handleDownload(item.DownloadCode)}>Download</button>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
export default LoaderList
